import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const useFabStyles = makeStyles()(({ spacing, shadows, palette }: Theme) => ({
  root: {
    position: 'absolute',
    bottom: spacing(2),
    right: spacing(2),
    zIndex: 1,
    backgroundColor: palette.success.main,
    '&:hover': {
      backgroundColor: palette.success.main,
    },
  },
  subMenusBox: {
    position: 'absolute',
    bottom: spacing(9),
    right: spacing(2),
    zIndex: 1,
    paddingRight: spacing(1),
  },
  buttonWrapper: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    marginBottom: spacing(2),
  },
  buttonText: {
    display: 'inline-flex',
    marginRight: '10px',
    lineHeight: spacing(3),
    backgroundColor: 'white',
    padding: spacing(1),
    borderRadius: spacing(1),
    boxShadow: shadows[2],
  },
  iconWrapper: {
    display: 'inline-flex',
    backgroundColor: 'white',
    borderRadius: '50%',
    padding: spacing(1),
    boxShadow: shadows[2],
  },
}));
